<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner home clearfix">
      <userInfo></userInfo>
      <div class="fl">
        <classData></classData>
        <classManage></classManage>
      </div>
      <div class="fr">
        <!-- <subject></subject> -->
        <resource></resource>
        <homework></homework>
        <teachingTrack></teachingTrack>
      </div>
    </div>
  </div>
</template>


<script>
import URL from "@/api/index";
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import userInfo from "@/components/home/userInfo.vue";
import subject from "@/components/home/subject.vue";
import resource from "@/components/home/resource.vue";
import classData from "@/components/home/classData.vue";
import classManage from "@/components/home/classManage.vue";
import homework from "@/components/home/homework.vue";
import teachingTrack from "@/components/home/teachingTrack.vue";
export default {
  data() {
    return {
      NewDynamicList: "",
      getSpace_data: "",
      dongshow: true,
      pagenum: "10",
      isshare: false,
      Token: JSON.parse(localStorage.getItem("loginInfo")).token,
      Userid: "",
      isshow: true,
      isstart: "start",
      data: ["", ""],
      Spaceid: "",
      
    };
  },
  components: {
    top,
    navMenu,
    subject,
    userInfo,
    classData,
    classManage,
    resource,
    homework,
    teachingTrack,
  },
  mounted() {
    this.login(JSON.parse(localStorage.getItem("loginInfo")).token);
  },
  methods: {
    login(e) {
      var tokengetuser_data = {
        token: e,
      };
      this.$post(URL.tokengetuser, tokengetuser_data).then((item) => {
        let info = item.result;
        // console.log(info);
        localStorage.setItem("info", JSON.stringify(info));
        this.Token = info.token;
        this.Userid = info.user_id;
        this.userspace(); //查询指定用户空间
      });
    },
    // 查询制定用户的空间
    userspace() {
      var userdata = {
        token: this.Token,
      };
      this.$post(URL.userspace, userdata).then((item) => {
        this.userspacelist = item.result;
        var spacelist = this.userspacelist;
        // console.log(spacelist);
        if (item.state == 0) {
          spacelist.forEach((item) => {
            if (item.space_type.substring(0, 2) == "01") {
              //没有01开头的空间则不显示班级圈，学校圈  此判断只判断有没有班级圈
              let routerstate = "1";
              localStorage.setItem("routerstate", JSON.stringify(routerstate));
            }
            if (item.space_type == "0000") {
              this.Spaceid = item.space_id;
            } else if (item.space_type == "0001") {
              this.Spaceid = item.space_id;
            } else if (item.space_type == "0101") {
              this.Spaceid = item.space_id;
            }
          });
          this.getSpace(); //查询空间
        }
      });
    },
    // 查询空间
    getSpace() {
      var getspacedata = {
        token: this.Token,
        spaceid: this.Spaceid,
      };
      this.$post(URL.getSpace, getspacedata).then((res) => {
        // console.log(res);
        let getSpaceinfo = res.result;
        if (res.state === 0) {
          localStorage.setItem("getSpaceinfo", JSON.stringify(getSpaceinfo));
          // location.reload();
          // this.$router.go(0)
        }
        // else {
        //   // 没有信息跳转申请空间
        //   this.$router.push({
        //     //申请空间
        //     name: "infomalloc",
        //     query: {
        //       userInfo: this.userInfo,
        //       getSpaceinfo: this.getSpaceinfo,
        //       spaceid: this.Spaceid,
        //     },
        //   });
        // }
      });
    },
    // 获取个人信息
    // user_details() {
    //   var that = this;
    //   var data = {
    //     token: JSON.parse(localStorage.getItem("loginInfo")).token,
    //   };
    //   this.$post(URL.user_details, data).then(function (res) {
        
    //   });
    // },

  },
};
</script>

<style lang='less' scoped>
.home {
  margin-top: 15px !important;
}
</style>
